var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',[_c('span',{staticClass:"c-skeleton c-skeleton--text",staticStyle:{"width":"80%"}}),_c('span',{staticClass:"c-skeleton c-skeleton--text",staticStyle:{"width":"50%"}}),_c('span',{staticClass:"c-skeleton c-skeleton--text",staticStyle:{"width":"70%"}})])])
}]

export { render, staticRenderFns }